import { render, staticRenderFns } from "./customer-forms-list.vue?vue&type=template&id=8b5fd34a&scoped=true&"
import script from "./customer-forms-list.vue?vue&type=script&lang=js&"
export * from "./customer-forms-list.vue?vue&type=script&lang=js&"
import style0 from "./customer-forms-list.vue?vue&type=style&index=0&id=8b5fd34a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5fd34a",
  null
  
)

export default component.exports